module.exports = __webpack_public_path__ + "editor-img-placeholder-677b2452a2beb8468e5226017fbafc61.png";